import type React from 'react'
import styles from './ErrorState.module.css'
import { MagnifierGlyph } from './icons/SdGlyphs'
import { StationDetailsCopy, type StationDetailsCopySet } from './copy'

export interface ErrorStateProps {
  /** Re-dispatches the station load action (spec §5.4). */
  onRetry: () => void
  /** Localised copy. @defaultValue {@link StationDetailsCopy} */
  copy?: StationDetailsCopySet
}

/**
 * Empty / error state — Figma S4 (6983:29813). Vertically-centred
 * magnifier + `Error.Title` + `Error.Subtitle`, with a bottom-pinned
 * full-width Retry pill (`background/inverted` / `text/inverted`).
 * a11y ids `station-details-error` + `station-details-retry`.
 */
export function ErrorState({
  onRetry,
  copy = StationDetailsCopy,
}: ErrorStateProps): React.ReactElement {
  return (
    <div className={styles.root} data-testid="station-details-error">
      <div className={styles.center}>
        <MagnifierGlyph size={44} className={styles.icon} />
        <p className={styles.title}>{copy.ErrorTitle}</p>
        <p className={styles.subtitle}>{copy.ErrorSubtitle}</p>
      </div>
      <div className={styles.ctaRow}>
        <button
          type="button"
          onClick={onRetry}
          data-testid="station-details-retry"
          className={styles.retry}
        >
          {copy.ErrorRetry}
        </button>
      </div>
    </div>
  )
}
